import { useEffect } from 'react'
import { useLocation, Redirect } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import SmartCitationsPanel from 'components/home/SmartCitationsPanel'
import Hero from 'components/home/Hero'
import { toggleModal, MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import { fetchStats } from 'store/home/actions'
import { setResetPasswordMode, setResetPasswordToken, verifyResetPasswordToken } from 'store/reset-password-modal/actions'
import qs from 'query-string'
import PartnersLinkPanelHomepage from '../components/partners/PartnersLinkPanelHomepage'
import AwardsAndPress from '../components/partners/Awards'
import NavBar from '../components/navbar/NavBar'
import TalkToUs from '../components/partners/TalkToUs'
import FeaturesPanel from '../components/home/FeaturesPanel'
import Endorsements from '../components/home/Endorsements'
import * as analytics from 'lib/analytics'
import { Helmet } from 'react-helmet'

import styles from './styles/HomeApp.css'

import homeStore from 'store/home'
import loginModalStore from 'store/login-modal'
import resetPasswordModalStore from 'store/reset-password-modal'
import injectAsyncStore from 'lib/inject-async-store'

const HomeApp = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const stats = useSelector(({ home }) => home.stats)
  const hasUser = useSelector(({ ui }) => ui.hasUser)
  const fetchingUser = useSelector(({ ui }) => ui.fetchingUser)
  const user = useSelector(({ ui }) => ui.user)

  useEffect(() => {
    if (!stats) {
      dispatch(fetchStats())
    }
  }, [])

  useEffect(() => {
    if (!fetchingUser && 'referenceCheck' in qs.parse(location.search)) {
      dispatch(
        toggleModal(user ? 'referenceCheck' : 'login', true, MODAL_FROM_CONTEXTS.REFERENCE_CHECK)
      )
    }
  }, [fetchingUser, location])

  useEffect(() => {
    if (fetchingUser) return
    analytics.event({
      category: 'Homepage',
      action: 'View Home Page'
    })
  }, [fetchingUser])

  return (
    <>
      {hasUser && location.pathname === '/' && <Redirect to={'/users/me/feed' + location.search} />}
      <Helmet>
        <link rel='canonical' href='https://scite.ai/' />
        <meta property='og:image' content='http://image.thum.io/get/ogImage/https://scite.ai?bannerClosed=true' />
        <meta property='twitter:image' content='http://image.thum.io/get/ogImage/https://scite.ai?bannerClosed=true' />
      </Helmet>
      <div>
        <div className={styles.home}>
          <Hero>
            <NavBar staticPage homePage />
          </Hero>
          <PartnersLinkPanelHomepage />
          <SmartCitationsPanel />
          <FeaturesPanel />
          <AwardsAndPress />
          <Endorsements className={styles.endorsements} />
          <TalkToUs join />
        </div>
      </div>
    </>
  )
}

export const getInitialActions = ({ req: { query } }) => {
  const actions = [fetchStats()]

  if (query.login === 'true') {
    return [
      ...actions,
      toggleModal('login', true)
    ]
  }

  if (query.resetPasswordToken) {
    return [
      ...actions,
      toggleModal('resetPassword'),
      setResetPasswordMode('endResetPassword'),
      setResetPasswordToken(query.resetPasswordToken),
      verifyResetPasswordToken(query.resetPasswordToken)
    ]
  }

  return actions
}

export default injectAsyncStore({
  home: homeStore,
  resetPasswordModal: resetPasswordModalStore,
  loginModal: loginModalStore
})(HomeApp)
